import { useState, useEffect } from "react";

import { CssBaseline, ThemeProvider } from "@mui/material";
import { Route, Routes, useLocation, Navigate, useNavigate } from "react-router-dom";

// Admin Components
import Sidebaradmin from "./scenes/global/Sidebar";
import AdminLogin from "./components/Admin/Login";
import UserList from "./components/Admin/User/List";
import UserDetails from "./components/Admin/User/userDetails";
import UserApproval from "./components/Admin/User/Approval";
import ImageGallery from "./components/Admin/User/Approval/Imageget";
import RejectedList from "./components/Admin/User/Rejected/rejected";
import RejectDetails from "./components/Admin/User/Rejected/userDetails";
import ReportList from "./components/Admin/User/Reports/reports";
import ReportDetails from "./components/Admin/User/Reports/reportsdetails";

import Bar from "./scenes/bar";
import Calendar from "./scenes/calendar/calendar";

import Dashboard from "./scenes/dashboard";
import Dashboard2 from "./scenes/dashboard2";
import FAQ from "./scenes/faq";
import Form from "./scenes/form";
import Geography from "./scenes/geography";

import Topbar from "./scenes/global/Topbar";
import Invoices from "./scenes/invoices";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import AddPromotioncode from "./scenes/promotionalCodes/AddPromotionalcode";
import PromotionalCodes from "./scenes/promotionalCodes/CodesList";
import Details from "./scenes/promotionalCodes/Details";
import ShowphoneAndEmail from "./scenes/showPhoneandEmail/showPhoneandEmail";
import Team from "./scenes/team";
import { ColorModeContext, useMode } from "./theme";

import { GetStarted } from "./components/get-started";

// SignUp onBoarding components
// SignUp onBoarding components
import { SignupPhone as OldSignupPhone } from "./components/SignUp/onBoarding/signup-verifyphone";
import { Entercode as OldEntercode } from "./components/SignUp/onBoarding/entercode";
import { EmailVerify as OldEmailVerify } from "./components/SignUp/onBoarding/email-verify";

import { SignupPhone as NewSignupPhone } from "./pages/Auth/Signup/Signup";
import { Entercode as NewEntercode } from "./pages/Auth/EnterCode/EnterCode";
import { EmailVerify as NewEmailVerify } from "./pages/Auth/EmailVerify/EmailVerify";
import { BasicDetails } from "./components/SignUp/onBoarding/basic-details";
import { AbtYourself as OldAbtYourself } from "./components/SignUp/onBoarding/abt-yourself";
import { AboutYourself as NewAboutYourself } from "./pages/Onboarding/AboutYourself/AboutYourself";
import { Lifestyle as Lifestyle } from "./pages/Onboarding/Lifestyle/Lifestyle";
import { LocationSelection as NewLocationSelection } from "./pages/Onboarding/LocationSelection/LocationSelection";
import { Selfie as OldSelfie } from "./components/SignUp/onBoarding/take-selfie1";
import { PhotoUpload as NewPhotoUpload } from "./pages/Onboarding/PhotoUpload/PhotoUpload";
import { Personality as NewPersonality } from "./pages/Onboarding/Personality/Personality";
import { Located } from "./components/SignUp/onBoarding/located";
import { Religion } from "./components/SignUp/onBoarding/religion";
import { Education } from "./components/SignUp/onBoarding/education";
import { JobTitle } from "./components/SignUp/onBoarding/job-title";
import ApproveEmail from "./components/SignUp/onBoarding/ApproveEmail";
import Height from "./components/SignUp/onBoarding/Height";
import OldKidsAndFamily from "./components/SignUp/onBoarding/KidsAndFamily";
import { RelationshipFamily as NewRelationshipFamily } from "./pages/Onboarding/RelationshipFamily/RelationshipFamily";
import OldPersonality from "./components/SignUp/onBoarding/Personality";
import ProfileAnswers from "./components/SignUp/onBoarding/ProfileAnswers";
import SmokeAndFamily from "./components/SignUp/onBoarding/SmokeAndDrink";

import { LP as OldLP } from "./components/LP";
import { Home as NewHome } from "./pages/Home";
import { FaqPage } from "./components/faq-pg";
import { PrivacyPolicy } from "./components/privacy-policy";
import { Tnc } from "./components/tnc";

import { GetInTouch } from "./components/get-in-touch";
import { SuccessPage } from "./components/success-stories-pg";

import { SignIn } from "./components/sign-in/signin";
import { SignInEmail } from "./components/sign-in/signin-email";
import { SignInEmailOTP } from "./components/sign-in/signin-email-otp";
import { SignInEmailSuccessful } from "./components/sign-in/signin-email-successful";
import { SignInPhoneOTP } from "./components/sign-in/signin-phone-otp";
import { SignInPhoneSuccessful } from "./components/sign-in/signin-phone-successful";
import { SignInOptions } from "./components/sign-in/sign-in-options";
import Login from "./pages/Auth/Login/Login";

import ProtectedRoute from "./components/PrivateRoute/ProtectedRoute";
import AdminProtectedRoute from "./components/PrivateRoute/AdminProtectedRoute";

import { AboutUsPage } from "./components/aboutus-pg";
import TotalCount from "./components/totalcount";
import { Video2 } from "./components/video2";

import EditDetails from "./scenes/promotionalCodes/Editpromotionalcode";

import AccountApproved from "./components/AccountApproved";
import AccountNotApproved from "./components/AccountNotApproved";
import AccountPending from "./components/AccountPending";
import AlmostThere from "./components/AlmostThere";

//Account-setting
import PaymentMethod from "../src/components/Account-Settings/payment/paymentMethod";
import Fillpaymentdetails from "./components/Account-Settings/payment/SelectPlan/FIllDetailForPayment/fillpaymentdetails";
import AddPaymentMethod from "./components/Account-Settings/payment/addpaymentmethod";
import BillingHistory from "./components/Account-Settings/payment/billinghistory";
import PaymentNew from "./components/Account-Settings/payment/newpayment/paymentNew";
import CardandPayment from "./components/Account-Settings/payment/CardAndCoupon";
import { AccountSetting } from "./components/Account-Settings/accountSetting";
import { PrivacyPolicySetting } from "./components/Account-Settings/privacyPolicy";
import { TermsConditions } from "./components/Account-Settings/termandconditons";
import UnsubscribeComponent from "./components/Account-Settings/unsubscribeEmail";

//UpdateProfile
import UpdateAnswers from "./components/UpdateProfile/screens/EditAnswerAndQuestion/editanswer";
import EditPicture from "./components/UpdateProfile/screens/PictureEdit/pictureedit";
import Preview from "./components/UpdateProfile/screens/Preview/Preview";
import UpdateProfile from "./components/UpdateProfile/screens/Profile";
import Drinkupdate from "./components/UpdateProfile/screens/UserDetailsUpdateScreen/Drink/drink";
import { GenderUpdate } from "./components/UpdateProfile/screens/UserDetailsUpdateScreen/Gender/Gender";
import HeightUpdate from "./components/UpdateProfile/screens/UserDetailsUpdateScreen/Height/height";
import { JobTitleUpdate } from "./components/UpdateProfile/screens/UserDetailsUpdateScreen/Job/job";
import PersonalityProfile from "./components/UpdateProfile/screens/UserDetailsUpdateScreen/Personality/personality";
import { ReligionUpdate } from "./components/UpdateProfile/screens/UserDetailsUpdateScreen/Religion/religion";
import KidsAndFamilyUpdate from "./components/UpdateProfile/screens/UserDetailsUpdateScreen/Whatsaboutfamily/familyplan";
import { BasicDetailsUpdate } from "./components/UpdateProfile/screens/UserDetailsUpdateScreen/age/age";
import { EducationUpdate } from "./components/UpdateProfile/screens/UserDetailsUpdateScreen/educations/educations";
import KidsUpdate from "./components/UpdateProfile/screens/UserDetailsUpdateScreen/havekids/havekids";
import { LanguageUpdate } from "./components/UpdateProfile/screens/UserDetailsUpdateScreen/languages/languages";
import { LocatedUpdate } from "./components/UpdateProfile/screens/UserDetailsUpdateScreen/locations/locations";
import Smokeupdate from "./components/UpdateProfile/screens/UserDetailsUpdateScreen/smoke/smoke";
import HelpSupport from "./components/UpdateProfile/screens/help&support/helpandsupport";
import { WantGenderUpdate } from "./components/UpdateProfile/screens/UserDetailsUpdateScreen/wantgender/wantgender";

//user-flow
import Home from "./components/userflow/screens/Home";
import Chat from "./components/userflow/screens/chat/Chat";
import ChatWith from "./components/userflow/screens/chat/ChatWith";
import PauseMyAccount from "./components/userflow/screens/pause/pause";
import Preferences from "./components/userflow/screens/preferences/Preferences";
import ProfileDetails from "./components/userflow/screens/profile-details/ProfileDetails";
import Recommendations from "./components/userflow/screens/recommendations/Recommendations";
import { useCookies } from "./hooks/useCookies";
import Verify from "./components/verify";
import Analytics from "./components/Analytics";
import * as userActions from "./actions/user";
import * as authActions from "./actions/auth";
import CropImage from "./components/cropimage/cropimage";
import TestStripePayment from "./components/Test/TestStripePayment";

// Global handler to check if user should resume signup
const ResumptionHandler = () => {
  const navigate = useNavigate();
  const { getCookie, setCookie } = useCookies();
  const location = useLocation();

  useEffect(() => {
    const userId = getCookie('userId');
    const token = getCookie('token');
    
    // Only check if we are on the Home page or public pages
    const publicPaths = ['/', '/signup', '/signin', '/signinoptions'];
    if (userId && token && publicPaths.includes(location.pathname)) {
      
      const checkResumeStatus = async () => {
        try {
          const detail = await userActions.getEmailDetail();
          if (detail && detail.email) {
            // User is authenticated but maybe not finished
            const verification = await authActions.checkEmailVerification();
            
            if (verification && !verification.emailVerified) {
              const confirm = window.confirm("Welcome back! You haven't verified your email yet. Continue signup?");
              if (confirm) navigate("/emailverify");
              return;
            }

            if (detail.completed === 0 || detail.completed === '0') {
              const confirm = window.confirm("Welcome back! You have some steps left to complete your profile. Continue now?");
              if (confirm) navigate("/abtyourself");
            }
          }
        } catch (error) {
          console.error("Resumption check failed", error);
        }
      };
      
      checkResumeStatus();
    }
  }, []); // Only run once on app load

  return null;
};

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const { getCookie } = useCookies();

  const location = useLocation();
  const admintoken = getCookie("Admintoken");
  const path = window.location.pathname;

  const isNewUI = process.env.REACT_APP_UI_VERSION?.trim() === 'modern';

  const adminProtectedRouteLists = [
    "/dashboard",
    "/dashboard2",
    "/team",

    "/admin/user/list",
    "/admin/user/detail/:id",

    "/admin/user/approval",
    "/admin/user/approval/:id",

    "/admin/user/rejected",
    "/admin/user/rejected/:id",

    "/admin/user/report",
    "/admin/user/report/:id",

    "/promo-codes",
    "/promo-codes/:id",

    "/showPhoneandEmail",

    "/invoices",
    "/count",
    "/form",
    "/bar",
    "/pie",
    "/line",
    "/faq",
    "/calendar",
    "/geography",
    "/addpromotionalcode",
    "/editpromotionalcode/:id",
  ];

  const adminLikePaths = [
    "/admin",
    "/SuccessPage",
    "/aboutus",
    "/GetInTouch",
    "/termandconditions",
    "/PrivacyPolicyDetails",
    "/dashboard",
    "/dashboard2",
    "/promo-codes",
    "/analytics",
  ];

  const isAdminProtectedRoute = adminProtectedRouteLists.some((route) =>
    location.pathname.startsWith(route.split(":")[0])
  );

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app" style={{ margin: "0 auto" }}>
          <ResumptionHandler />
          {admintoken && isAdminProtectedRoute && (
            <Sidebaradmin isSidebar={isSidebar} />
          )}
          <main
            className={
              adminLikePaths.some((adminPath) => path.startsWith(adminPath)) ||
              path === "/"
                ? "container-fluid container-size-admin"
                : "container-fluid container-size"
            }
          >
            {admintoken && isAdminProtectedRoute && (
              <Topbar setIsSidebar={setIsSidebar} />
            )}
            <Routes>
              {/* Admin Protected Route */}
              <Route path="/adminlogin" element={<AdminLogin />} />
              <Route
                path="/admin/user/list"
                element={
                  <AdminProtectedRoute>
                    <UserList />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/admin/user/detail/:id"
                element={
                  <AdminProtectedRoute>
                    <UserDetails />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/admin/user/approval"
                element={
                  <AdminProtectedRoute>
                    <UserApproval />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/admin/user/approval/:id"
                element={
                  <AdminProtectedRoute>
                    <UserDetails />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/admin/user/rejected"
                element={
                  <AdminProtectedRoute>
                    <RejectedList />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/admin/user/rejected/:id"
                element={
                  <AdminProtectedRoute>
                    <RejectDetails />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/admin/user/report"
                element={
                  <AdminProtectedRoute>
                    <ReportList />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/admin/user/report/:id"
                element={
                  <AdminProtectedRoute>
                    <ReportDetails />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/analytics"
                element={
                  <AdminProtectedRoute>
                    <Analytics />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <AdminProtectedRoute>
                    <Dashboard />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/dashboard2"
                element={
                  <AdminProtectedRoute>
                    <Dashboard2 />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/team"
                element={
                  <AdminProtectedRoute>
                    <Team />
                  </AdminProtectedRoute>
                }
              />

              <Route
                path="/promo-codes"
                element={
                  <AdminProtectedRoute>
                    <PromotionalCodes />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/promo-codes/add"
                element={
                  <AdminProtectedRoute>
                    <AddPromotioncode />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/promo-codes/edit/:id"
                element={
                  <AdminProtectedRoute>
                    <EditDetails />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/promo-codes/:id"
                element={
                  <AdminProtectedRoute>
                    <Details />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/showPhoneandEmail"
                element={
                  <AdminProtectedRoute>
                    <ShowphoneAndEmail />
                  </AdminProtectedRoute>
                }
              />

              <Route
                path="/invoices"
                element={
                  <AdminProtectedRoute>
                    <Invoices />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/count"
                element={
                  <AdminProtectedRoute>
                    <TotalCount />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/form"
                element={
                  <AdminProtectedRoute>
                    <Form />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/bar"
                element={
                  <AdminProtectedRoute>
                    <Bar />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/pie"
                element={
                  <AdminProtectedRoute>
                    <Pie />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/line"
                element={
                  <AdminProtectedRoute>
                    <Line />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/faq"
                element={
                  <AdminProtectedRoute>
                    <FAQ />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/calendar"
                element={
                  <AdminProtectedRoute>
                    <Calendar />
                  </AdminProtectedRoute>
                }
              />
              <Route
                path="/geography"
                element={
                  <AdminProtectedRoute>
                    <Geography />
                  </AdminProtectedRoute>
                }
              />

              {/* Public Routes */}
              <Route path="/img" element={<ImageGallery />} />
              <Route path="/" element={isNewUI ? <NewHome /> : <OldLP />} />
              <Route path="/SuccessPage" element={<SuccessPage />} />
              <Route path="/FaqPage" element={<FaqPage />} />
              <Route path="/GetInTouch" element={<GetInTouch />} />
              <Route path="/aboutus" element={<AboutUsPage />} />
              <Route path="/Tnc" element={<Tnc />} />
              <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
              <Route path="/video2" element={<Video2 />} />

              <Route path="/signup" element={isNewUI ? <NewSignupPhone /> : <OldSignupPhone />} />
              <Route path="/entercode" element={isNewUI ? <NewEntercode /> : <OldEntercode />} />

              {isNewUI && <Route path="/login" element={<Login />} />}
              <Route path="/signinoptions" element={<SignInOptions />} />

              <Route path="/signin" element={<SignIn />} />
              <Route path="/signinphoneotp" element={<SignInPhoneOTP />} />

              <Route path="/signinemail" element={<SignInEmail />} />
              <Route path="/signinemailotp" element={<SignInEmailOTP />} />

              <Route
                path="/signinphonesuccessful"
                element={<SignInPhoneSuccessful />}
              />
              <Route
                path="/signinemailsuccessful"
                element={<SignInEmailSuccessful />}
              />

              {/* User Protected Route */}
              <Route
                path="/emailverify"
                element={
                  <ProtectedRoute>
                    {isNewUI ? <NewEmailVerify /> : <OldEmailVerify />}
                  </ProtectedRoute>
                }
              />
              <Route
                path="/getstarted"
                element={
                  <ProtectedRoute>
                    <GetStarted />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/basicdetails"
                element={
                  <ProtectedRoute>
                    <BasicDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/abtyourself"
                element={
                  <ProtectedRoute>
                    {isNewUI ? <NewAboutYourself /> : <OldAbtYourself />}
                  </ProtectedRoute>
                }
              />
              <Route
                path="/selfie"
                element={
                  <ProtectedRoute>
                    {isNewUI ? <NewPhotoUpload /> : <OldSelfie />}
                  </ProtectedRoute>
                }
              />
              <Route path="/imagecrop" element={<CropImage />} />
              <Route
                path="/located"
                element={
                  <ProtectedRoute>
                    {isNewUI ? <NewLocationSelection /> : <Located />}
                  </ProtectedRoute>
                }
              />
              <Route
                path="/religion"
                element={
                  <ProtectedRoute>
                    <Religion />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/edu"
                element={
                  <ProtectedRoute>
                    <Education />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/jobtitle"
                element={
                  <ProtectedRoute>
                    <JobTitle />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/height"
                element={
                  <ProtectedRoute>
                    <Height />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/personality"
                element={
                  <ProtectedRoute>
                    {isNewUI ? <NewPersonality /> : <OldPersonality />}
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile-answers"
                element={
                  <ProtectedRoute>
                    <ProfileAnswers />
                  </ProtectedRoute>
                }
              />
              
              <Route
                path="/kids-family"
                element={
                  <ProtectedRoute>
                    {isNewUI ? <NewRelationshipFamily /> : <OldKidsAndFamily />}
                  </ProtectedRoute>
                }
              />
              <Route
                path="/lifestyle"
                element={
                  <ProtectedRoute>
                    <Lifestyle />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/smoke-drink"
                element={
                  <ProtectedRoute>
                    <SmokeAndFamily />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/almost-there"
                element={
                  <ProtectedRoute>
                    <AlmostThere />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/pending"
                element={
                  <ProtectedRoute>
                    <AccountPending />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/not-approved"
                element={
                  <ProtectedRoute>
                    <AccountNotApproved />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/approved"
                element={
                  <ProtectedRoute>
                    <AccountApproved />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user/verify/:token"
                element={
                  <ProtectedRoute>
                    <Verify />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/accoutsetting"
                element={
                  <ProtectedRoute>
                    <AccountSetting />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/unsubscribe"
                element={
                  <ProtectedRoute>
                    <UnsubscribeComponent />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/PrivacyPolicyDetails"
                element={
                  <ProtectedRoute>
                    <PrivacyPolicySetting />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/termandconditions"
                element={
                  <ProtectedRoute>
                    <TermsConditions />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/paymentmethod"
                element={
                  <ProtectedRoute>
                    <PaymentMethod />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/billinghistory"
                element={
                  <ProtectedRoute>
                    <BillingHistory />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/selectplan"
                element={
                  <ProtectedRoute>
                    <PaymentNew />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/cardandpayment"
                element={
                  <ProtectedRoute>
                    <CardandPayment />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/addpaymentmethod"
                element={
                  <ProtectedRoute>
                    <AddPaymentMethod />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/paymentdetails"
                element={
                  <ProtectedRoute>
                    <Fillpaymentdetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/updateprofile"
                element={
                  <ProtectedRoute>
                    <UpdateProfile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/preview"
                element={
                  <ProtectedRoute>
                    <Preview />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/editpicture"
                element={
                  <ProtectedRoute>
                    <EditPicture />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/updateanswer"
                element={
                  <ProtectedRoute>
                    <UpdateAnswers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/personalityupdate"
                element={
                  <ProtectedRoute>
                    <PersonalityProfile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/updategender"
                element={
                  <ProtectedRoute>
                    <GenderUpdate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/updatelocations"
                element={
                  <ProtectedRoute>
                    <LocatedUpdate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/updatereligion"
                element={
                  <ProtectedRoute>
                    <ReligionUpdate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/updateheight"
                element={
                  <ProtectedRoute>
                    <HeightUpdate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/updatejob"
                element={
                  <ProtectedRoute>
                    <JobTitleUpdate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/updatesmoke"
                element={
                  <ProtectedRoute>
                    <Smokeupdate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/updatedrink"
                element={
                  <ProtectedRoute>
                    <Drinkupdate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/updatefamilyplan"
                element={
                  <ProtectedRoute>
                    <KidsAndFamilyUpdate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/updatekids"
                element={
                  <ProtectedRoute>
                    <KidsUpdate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/updatelanguage"
                element={
                  <ProtectedRoute>
                    <LanguageUpdate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/updateeducations"
                element={
                  <ProtectedRoute>
                    <EducationUpdate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/updateage"
                element={
                  <ProtectedRoute>
                    <BasicDetailsUpdate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/helpsupport"
                element={
                  <ProtectedRoute>
                    <HelpSupport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/wantgender"
                element={
                  <ProtectedRoute>
                    <WantGenderUpdate />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/user/home"
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user/recommendations"
                element={
                  <ProtectedRoute>
                    <Recommendations />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user/preferences"
                element={
                  <ProtectedRoute>
                    <Preferences />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user/:id"
                element={
                  <ProtectedRoute>
                    <ProfileDetails />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/user/chat/with/:id"
                element={
                  <ProtectedRoute>
                    <ChatWith />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user/chat/:action/:type"
                element={
                  <ProtectedRoute>
                    <Chat />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user/chat/:action"
                element={
                  <ProtectedRoute>
                    <Chat />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/user/pause"
                element={
                  <ProtectedRoute>
                    <PauseMyAccount />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/test"
                element={
                  <ProtectedRoute>
                    <TestStripePayment />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
